import React from 'react';
import HotelBookingCard from './HotelBookingCard';
import HotelReservationCard from './HotelReservationCard';
import { groupByReservation } from '../utils/hotelUtils';

/**
 * The cards for a list of bookings: one per reservation. Dogs booked together
 * share a card; everything else keeps its own. Grouping happens within the list
 * given, so a dog checked in ahead of the rest shows up on its own where it is.
 * onCheckIn / onCheckOut receive an array of bookings from a reservation card.
 */
const HotelBookingCards = ({ bookings, ...handlers }) => (
    <>
        {groupByReservation(bookings).map(group => group.length > 1 ? (
            <HotelReservationCard key={group[0].reservationId} bookings={group} {...handlers} />
        ) : (
            <HotelBookingCard key={group[0]._id} booking={group[0]} {...handlers} />
        ))}
    </>
);

export default HotelBookingCards;
